// extracted by mini-css-extract-plugin
export default {"PromotionsForm":"PromotionsForm_PromotionsForm__wZHBx"};